import { render, staticRenderFns } from "./FormAccount.vue?vue&type=template&id=0f31590a"
import script from "./FormAccount.vue?vue&type=script&lang=js"
export * from "./FormAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports